<template>
    <b-card>
        <b-card-body class="p-0">
            <div>
                <b-overlay :show="loading" rounded="sm">
                    <b-form @submit.prevent="getData">
                        <b-row>
                            <b-col cols="12"><label for="input-1" class="mb-3"><strong>{{ $translate('company_name') }}<span
                                            class="red">*</span></strong></label>
                                <b-form-input id="input-1" :placeholder="$translate('enter_company_name')"
                                    v-model="form.companyName" required v-custom-validation="$textRequired()"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3" for="datepicker1"><strong>{{ $translate('from_date') }}</strong></label>
                                <date-picker id="datepick1" v-model="value" :config="options"
                                    :placeholder="$translate('select_date')"></date-picker>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label class="mb-3" for="datepicker2"><strong>{{ $translate('to_date') }}</strong></label>
                                <date-picker id="datepick2" v-model="value2" :config="options"
                                    :placeholder="$translate('select_date')"></date-picker>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label for="input-2" class="mb-3"><strong>{{ $translate('amount_due') }}<span
                                            class="red">*</span></strong></label>
                                <b-form-input id="input-2" :placeholder="$translate('enter_amount_due')" required
                                    v-custom-validation="$textRequired()"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="6" class="mt-3">
                                <label for="input-3" class="mb-3"><strong>{{ $translate('invoice_number') }}<span
                                            class="red">*</span></strong></label>
                                <b-form-input id="input-2" :placeholder="$translate('enter_invoice_number')" required
                                    v-custom-validation="$textRequired()"></b-form-input>
                            </b-col>
                            <b-col cols="12" class="text-center mt-4">
                                <b-button id="submit-form-btn" class="px-3 mr-2" size="fw" variant="blue-button" type="submit" :disabled="loading"
                                    :busy="loading">
                                    {{ loading ? $translate('submitting') : $translate('submit') }}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                
                    <b-modal v-model="modalShow" :title="$translate('due_invoices_table')" size="lg">
                        <b-table responsive sticky-header :per-page="perPage" :current-page="currentPage" :items="resData"
                            @paginate="onPageChange"></b-table>
                        <b-pagination v-model="currentPage" :total-rows="resData.length" :per-page="perPage"
                            size="sm"></b-pagination>
                        <download-excel :data="this.resData" :name="$translate('due_invoices')">
                            <b-button variant="primary"> {{ $translate('export_as_excel') }} </b-button>
                        </download-excel>
                    </b-modal>
                </b-overlay>
            </div>
        </b-card-body>
    </b-card>
</template>
<script>
import datePicker from 'vue-bootstrap-datetimepicker'
// import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
//import JsonExcel from 'vue-json-excel'

export default {
    components: {
        datePicker,
    },
    data() {
        return {
            form: {
                isoDate: null,
                isoDate2: null,
                companyName: null,
            },
            value: null,
            value2: null,
            options: {
                useCurrent: false,
                icons: {
                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle',
                },
            },
            loading: false,
            perPage: 5,
            currentPage: 1,
            modalShow: false,
        }
    },

    computed: {
        resData() {
            return this.$store.state.siteAdmin.resParams
        },
    },

    watch: {
        value: {
            handler: function () {
                console.log('Date', this.value)
                this.form.isoDate = new Date(this.value).toISOString()
            },
        },
        value2: {
            handler: function () {
                console.log('Date', this.value)
                this.form.isoDate2 = new Date(this.value2).toISOString()
            },
        },

        resData: {
            handler: function (val) {
                console.log('Lambda Data', val)
            },
            deep: true,
        },
    },

    methods: {
        async getData() {
            try {
                this.loading = true
                await this.$store.dispatch(
                    'siteAdmin/retrieveSiteData',
                    this.form
                )
                this.loading = false
                this.showModal()
            } catch (err) {
                console.log(err)
            }
        },
        showModal() {
            this.modalShow = true
        },
        onPageChange(newPage) {
            this.currentPage = newPage
        },
    },
}
</script>
